package one.healthium.onboarding.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.onboarding.domain.configs.RelateToStatementScreenConfig
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.modifier.clickableHaptic
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2

@Composable
internal fun RelateToStatementContent(
    modifier: Modifier = Modifier,
    screenConfig: RelateToStatementScreenConfig,
    userState: UserProfileUiModel,
    selectedOption: Int?,
    onOptionChanged: (Int) -> Unit,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .statusBarsPadding()
            .navigationBarsPadding()
            .padding(horizontal = 24.dp)
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppText(
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.header,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(24.dp))
        AppText(
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(24.dp))
        Spacer(Modifier.weight(1f))
        Row(
            horizontalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            repeat(5) { index ->
                Item(
                    text = "${index + 1}",
                    selected = selectedOption == index,
                    onClick = {
                        onOptionChanged(index)
                        onNextClicked()
                    }
                )
            }
        }
        Spacer(Modifier.height(12.dp))
        Row(
            modifier = Modifier.fillMaxWidth()
        ) {
            screenConfig.case1Title?.let {
                Text(
                    text = it,
                    style = AppTheme.textStyles.body1,
                    color = AppTheme.colors.text100,
                )
            }
            Spacer(Modifier.weight(1f))
            screenConfig.case5Title?.let {
                Text(
                    text = it,
                    style = AppTheme.textStyles.body1,
                    color = AppTheme.colors.text100,
                )
            }
        }
        Spacer(Modifier.height(60.dp))
        Spacer(Modifier.weight(1f))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp),
            onClick = onNextClicked,
            enabled = selectedOption != null,
            text = screenConfig.ctaTitle,
        )
        Spacer(Modifier.height(24.dp))
    }
}

@Composable
private fun RowScope.Item(
    text: String,
    selected: Boolean,
    onClick: () -> Unit,
) {
    Box(
        modifier = Modifier
            .weight(1f)
            .height(80.dp)
            .clip(AppTheme.shapes.small)
            .clickableHaptic { onClick() }
            .background(
                color = if (selected) AppTheme.colors.primary else gray_2,
                shape = AppTheme.shapes.small,
            ),
    ) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center,
        ) {
            AppText(
                text = text,
                style = AppTheme.textStyles.headerSemiBold,
                color = if (selected) AppTheme.colors.textInverted100 else AppTheme.colors.text100
            )
        }
    }
}
